import axios from "../utils/axios";

//download schema
export const downloadSchema = () => {
    return axios.get(`/PlannedMaintenance/GetExcelSchema`, {responseType:"blob"});
};

export const downloadExamples = (plantId) => {
    return axios.get(`/PlannedMaintenance/GetExampleValuesExcel`, {responseType:"blob"}, { params: { plantId: plantId } });
};

export const excelToListSingle = (payload) => {
    return axios.post(`/PlannedMaintenance/ExcelToList`, payload);
};

export const excelUpload = (payload) => {
    return axios.post(`/PlannedMaintenance/PersistFromCache?fileChecksum=${payload}`);
};

